import { useState, useCallback } from 'react';
import {GridRecords} from "../props";

export const useGridController = (defaultItems?: GridRecords) => {
  const [items, setItems] = useState<GridRecords>(defaultItems || {});

  const insertItem = useCallback((index: string, component: React.ReactNode) => {
    setItems((prevItems) => ({
      ...prevItems,
      [index]: { content: component },
    }));
  }, []);

  const removeItem = useCallback((index: string) => {
    setItems((prevItems) => {
      const newItems = { ...prevItems };
      delete newItems[index];
      return newItems;
    });
  }, []);

  const clear = useCallback(() => setItems({}), []);

  return {
    items,
    insertItem,
    removeItem,
    clear,
    setItems
  };
};
